module.exports = __webpack_public_path__ + "static/bg-6befa5fe50faca3cf2048267f8084168.jpg";